import { useEffect } from 'react'
import { FetchParams, usePaginateContacts } from '@hooks'

// Contacts per request for the map: fewer round trips than the list's 10.
export const MAP_CONTACTS_PAGE_SIZE = 100

/**
 * The contacts to place on the map: all of them, not only the first page of
 * the list. The next pages load on their own until every contact is in.
 */
export function useMapContacts(params: FetchParams) {
  const query = usePaginateContacts({ ...params, limit: MAP_CONTACTS_PAGE_SIZE })
  const { hasNextPage, isFetchingNextPage, isFetchNextPageError, fetchNextPage } = query

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage && !isFetchNextPageError) fetchNextPage()
  }, [hasNextPage, isFetchingNextPage, isFetchNextPageError, fetchNextPage])

  return query
}
